import { render } from "./CodigoEnviar.vue?vue&type=template&id=2d11900c"
import script from "./CodigoEnviar.vue?vue&type=script&lang=js"
export * from "./CodigoEnviar.vue?vue&type=script&lang=js"

import exportComponent from "/home/nodejs/front/oxyplus-acuicultura-monitorweb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__